import angular from 'angular';

import component from './cvt-issues-section.component';

const CvtIssuesSection = angular
    .module('control-room.internal.components.cvt.components.cvt-dashboard.components.cvt-issues-section', [])
    .component('crCvtIssuesSection', component);

export default CvtIssuesSection;
